import { render } from "./CreateGame.vue?vue&type=template&id=619bdfee&scoped=true"
import script from "./CreateGame.vue?vue&type=script&lang=js"
export * from "./CreateGame.vue?vue&type=script&lang=js"

import "./CreateGame.vue?vue&type=style&index=0&id=619bdfee&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-619bdfee"]])

export default __exports__